<template>
  <div class="header-background">
    <!-- Fila superior: Logo y Botón -->
    <div class="header-top">
      <div class="logo">
        <img
          src="../../assets/img/Landing/xtrim-pro-logo.png"
          alt="XtrimPro Logo"
        />
      </div>
      <div class="login-button-container">
        <login-ingreso-m />
      </div>
    </div>

    <!-- Fila inferior: Menú de navegación -->
    <div class="menu">
      <ul>
        <!-- <li><a href="#">INICIO ✨</a></li> -->
        <li><a href="/login">REGÍSTRATE ✨</a></li>
        <li><a href="#como-ganar">¿CÓMO GANAR? ✨</a></li>
        <!-- <li><a href="#">MAPA DE COBERTURA ✨</a></li> -->
        <li><a href="#preguntas">PREGUNTAS FRECUENTES ✨</a></li>
        <li><a href="#contacto">CONTÁCTANOS ✨</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import LoginIngresoM from "./LoginMobile.vue";

export default {
  name: "Landing-Mobile",
  components: {
    LoginIngresoM,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
/* Fondo principal */
.header-background {
  background-image: url("../../assets/img/Landing/bloque-superior-web.png");
  background-size: cover;
  background-position: center;
  width: 100%;
  height: auto;
  padding: 15px 20px 15px 20px;
}

/* Fila superior: Logo y Botón */
.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
}

/* Estilos del logo */
.logo {
  flex-shrink: 0;
}

.logo img {
  height: 50px;
}

/* Contenedor del botón de login */
.login-button-container {
  flex-shrink: 0;
  margin-right: -20px;
}

/* Menú de navegación - Distribuido abajo */
.menu {
  width: 100%;
  margin-top: 10px;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px 15px;
}

.menu ul li {
  position: relative;
}

.menu ul li a {
  font-size: 12px;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  padding-bottom: 5px;
  white-space: nowrap;
  transition: color 0.3s ease;
  display: block;
}

/* Efecto de hover con la línea amarilla */
.menu ul li a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: yellow;
  transition: width 0.3s ease;
}

.menu ul li a:hover::after {
  width: 100%;
}

.menu ul li a:hover {
  color: yellow;
}

/* Media queries para pantallas muy pequeñas */
@media (max-width: 360px) {
  .menu ul {
    gap: 10px 12px;
  }

  .menu ul li a {
    font-size: 10px;
  }

  .logo img {
    height: 45px;
  }
}
</style>
